"use client";

import { useLanguageContext } from "@/contexts/language-context";

export type Language = "zh" | "en";

export const useLanguage = () => {
	const {
		language,
		toggleLanguage,
		setLanguage,
		isLanguageManual,
		getTranslation,
	} = useLanguageContext();

	return {
		language,
		toggleLanguage,
		setLanguage,
		isLanguageManual,
		getTranslation,
	};
};
